import React from 'react';
import SidebarUnitDesktop from 'components/sidebar/components/SidebarUnitDesktop';
import { DocumentIcon } from 'assets/icons';

const PayslipManagementDL = ({ pathname }) => {
  return (
    <SidebarUnitDesktop
      routeName={'Paie & Factures'}
      routeSidebar={'/payslipManagement/payslips'}
    >
      <span className="shrink-0">
        <DocumentIcon
          wh={24}
          color={`${pathname.includes('payslipManagement') ? '#FF9600' : '#6B7280'}`}
        />
      </span>
      <span
        className={`ft-sm font-medium ml-3 ls:opacity-0 ls:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200 ${
          pathname.includes('payslipManagement') && '!text-[#FF9600]'
        }`}
      >
        Paie & Factures
      </span>
    </SidebarUnitDesktop>
  );
};

export default PayslipManagementDL;
